import { useLayoutEffect, useRef, useState } from 'react';

import { useDebounce } from './useDebounce';

export const useEllipsizeTextByParent = () => {
  const [isExceeded, setIsExceeded] = useState(false);
  const elemRef = useRef<HTMLAnchorElement>(null);

  const debouncedCompare = useDebounce(() => {
    if (elemRef.current && elemRef.current.parentElement) {
      const elemWidth = elemRef.current.scrollWidth || elemRef.current.offsetWidth;
      const parentWidth = elemRef.current.parentElement.offsetWidth;

      if (elemWidth >= parentWidth) {
        setIsExceeded(true);
      } else {
        setIsExceeded(false);
      }
    }
  }, 300);

  useLayoutEffect(() => {
    debouncedCompare();

    window.addEventListener('resize', debouncedCompare);

    return () => {
      window.removeEventListener('resize', debouncedCompare);
    };
  }, []);

  return { isExceeded, elemRef };
};
